import './RegisterBlock.less';
import React from 'react';
import Button from "../../../../bootstrap/components/button/Button";
import routes from "../../../routing/routes";
import __ from "../../../i18n";
import {useHistory} from "react-router-dom";
import screenSizeQueries from '../../../styles/screenSizeQueries';
import useMediaQuery from '../../../hooks/useMediaQuery';


export default function RegisterBlock({}) {

    const history = useHistory();

    const isMobile = useMediaQuery(screenSizeQueries.mobile);

    return <div className="register-block">
        <Button
            name="register"
            title={__('Create account')}
            size={isMobile ? 'small' : 'medium'}
            appearance="solid-primary"
            type="link-button"
            href={routes.register.getUrl()}
            onClick={(ev) => {
                ev.preventDefault();
                history.push(routes.register.getUrl());
            }}
        />
        <Button
            name="login"
            title={__('Login')}
            size={isMobile ? 'small' : 'medium'}
            appearance="outline-primary"
            type="link-button"
            href={routes.login.getUrl()}
            onClick={(ev) => {
                ev.preventDefault();
                history.push(routes.login.getUrl());
            }}
        />
    </div>;
}
